import { ReportStatuses, initialReportState } from '@navstation-portal/reporting/data-model/vessel-report';
import { authEvents } from '@navstation-portal/shared/data-access/auth';
import { signalStoreFeature } from '@ngrx/signals';
import { on, withReducer } from '@ngrx/signals/events';
import { reportEvents } from './report-events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withReportReducer<_>() {
  return signalStoreFeature(
    withReducer(
      on(reportEvents.getCarryoverData, () => ({
        reportType: null,
        reportNotFound: false,
        reportStatus: null,
      })),
      on(reportEvents.openReport, () => ({
        reportType: null,
        reportNotFound: false,
        loading: true,
        reportStatus: null,
      })),
      on(reportEvents.gotCarryoverData, ({ payload }) => () => {
        return {
          carryOverReport: payload,
        };
      }),
      on(reportEvents.gotFormFieldRules, ({ payload }) => () => {
        return {
          formFieldRules: payload,
        };
      }),

      on(reportEvents.gotFormRuleTemplate, ({ payload }) => () => {
        return {
          formRuleTemplate: payload,
        };
      }),

      on(reportEvents.createReportSuccess, () => ({
        reportNotFound: false,
        loading: false,
      })),
      on(reportEvents.openReportSuccess, ({ payload: { status } }) => ({
        reportNotFound: false,
        loading: false,
        reportStatus: status,
      })),
      on(reportEvents.openReportFailed, ({ payload }) => ({
        reportType: null,
        reportNotFound: payload.notFound,
        loading: false,
      })),
      on(reportEvents.createReportFailed, () => ({
        reportType: null,
        reportNotFound: false,
        loading: false,
      })),
      on(reportEvents.createNewReport, () => ({
        reportType: null,
        reportNotFound: false,
        localReportId: null,
        savedReportId: null,
        notes: null,
        loading: true,
        reportStatus: ReportStatuses.Started,
      })),
      on(reportEvents.saveReport, () => ({
        saving: true,
      })),
      on(reportEvents.saveReportSuccess, ({ payload: { reportId } }) => ({
        savedReportId: reportId,
        saving: false,
      })),
      on(reportEvents.saveReportFailed, () => ({
        saving: false,
      })),
      on(reportEvents.submitReport, () => ({
        submitting: true,
      })),
      on(reportEvents.submitReportSuccess, () => ({
        submitting: false,
        reportStatus: ReportStatuses.Completed,
      })),
      on(reportEvents.submitReportFailed, () => ({
        submitting: false,
      })),
      on(reportEvents.deleteReport, () => ({
        deleting: true,
      })),
      on(reportEvents.deleteReportSuccess, () => ({
        deleting: false,
      })),
      on(reportEvents.deleteReportFailed, () => ({
        deleting: false,
      })),
      on(reportEvents.setReportType, ({ payload: reportType }) => ({
        reportType,
        reportNotFound: false,
      })),
      on(reportEvents.setLocalReportId, ({ payload: localReportId }) => ({
        localReportId,
      })),
      on(reportEvents.setNotes, ({ payload: notes }) => ({
        notes,
      })),
      on(reportEvents.reset, () => initialReportState),
      on(authEvents.logoutSuccess, () => initialReportState)
    )
  );
}
